import { AlertTriangle, Check, Loader2 } from "lucide-react";
import type { FC } from "react";

import { StatusBadge, type StatusTone } from "@/components/ui/status-badge";

import type { ConnectorStatus } from "../types";

type Status = ConnectorStatus | "unknown";

export const STATUS_LABEL: Record<Status, string> = {
  connected: "Connected",
  pending: "Waiting for Authorization",
  error: "Needs Attention",
  not_connected: "Not Connected",
  unavailable: "Unavailable",
  unknown: "Not Available"
};

const TONE: Record<Status, StatusTone> = {
  connected: "success",
  pending: "warn",
  error: "danger",
  not_connected: "neutral",
  unavailable: "neutral",
  unknown: "neutral"
};

type Props = {
  status: Status;
  /** The Connect Link for this app is open in another tab. */
  connecting?: boolean;
  className?: string;
};

/** An app's connection state as a badge, shared by the Connectors page and the connect card. */
export const ConnectorStatusBadge: FC<Props> = ({
  status,
  connecting = false,
  className
}) => {
  if (connecting) {
    return (
      <StatusBadge className={className} data-testid="connector-status">
        <Loader2 className="animate-spin" />
        Connecting…
      </StatusBadge>
    );
  }
  return (
    <StatusBadge
      tone={TONE[status]}
      className={className}
      data-testid="connector-status"
    >
      {status === "connected" ? <Check /> : null}
      {status === "error" ? <AlertTriangle /> : null}
      {STATUS_LABEL[status]}
    </StatusBadge>
  );
};
